import { useMessageSource } from "react-message-source";
import * as Yup from "yup";
import { ProductRefType } from "../../../context/product-context/types";

export default function useProductValidator(): Yup.StringSchema {
  const { getMessage } = useMessageSource();

  const allProducts = Object.values(ProductRefType);
  return Yup.string().oneOf(
    allProducts,
    getMessage("Validation.message-required"),
  );
}
